/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Components,
  ComponentsParams,
  SchemaValidationErrorResponse,
  WeaponIndex
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Components list
 */
export const components = (
    params?: MaybeRefOrGetter<ComponentsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Components>(
      {url: `/components`, method: 'GET',
        params, signal
    },
      );
    }




export const getComponentsQueryKey = (params?: MaybeRefOrGetter<ComponentsParams>,) => {
    return [
    'components', ...(params ? [params] : [])
    ] as const;
    }


export const getComponentsQueryOptions = <TData = Awaited<ReturnType<typeof components>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ComponentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof components>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof components>>> = ({ signal }) => components(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof components>>, TError, TData>
}

export type ComponentsQueryResult = NonNullable<Awaited<ReturnType<typeof components>>>
export type ComponentsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Components list
 */

export function useComponents<TData = Awaited<ReturnType<typeof components>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ComponentsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof components>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Ship guns for the deflection check
 */
export const componentWeapons = (

 signal?: AbortSignal
) => {


      return axiosClient<WeaponIndex>(
      {url: `/components/weapons`, method: 'GET', signal
    },
      );
    }




export const getComponentWeaponsQueryKey = () => {
    return [
    'components','weapons'
    ] as const;
    }


export const getComponentWeaponsQueryOptions = <TData = Awaited<ReturnType<typeof componentWeapons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentWeapons>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentWeaponsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof componentWeapons>>> = ({ signal }) => componentWeapons(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof componentWeapons>>, TError, TData>
}

export type ComponentWeaponsQueryResult = NonNullable<Awaited<ReturnType<typeof componentWeapons>>>
export type ComponentWeaponsQueryError = ErrorType<unknown>


/**
 * @summary Ship guns for the deflection check
 */

export function useComponentWeapons<TData = Awaited<ReturnType<typeof componentWeapons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentWeapons>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentWeaponsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






